<template>
    <el-dialog
        :visible.sync="show"
        :before-close="handleClose"
        title="医学检查"
        width="900px"
        class="examination"
        >
        <div class="dialog-cont" >
            <el-form>
                <div class="cont flex">
                    <div class="cont-nav">
                        <div class="nav-list">
                             <ul >
                                <li :class="item.num==activeIndex?'active':''" v-for="(item,index) in navTab" :key="index" @click="tab_click(item)">{{item.value}}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cont-info">
                        <div class="info">
                            <el-form-item v-for="(item, index) in listData[activeVlaue]" :key="index" :label='item.name+"："' :label-width="labelWidth">
                                <div class="flex">
                                    <div class="card-input">
                                        <el-date-picker
                                            v-if="item.name=='检查时间'"
                                            value-format="yyyy-MM-dd"
                                            class="picker-date"
                                            v-model="item.title"
                                            type="date"
                                            placeholder="选择日期"
                                        ></el-date-picker>
                                        <el-input v-else  v-model="item.title"></el-input>
                                    </div>
                                    <div v-html="item.unitRender"></div>
                                </div>
                            </el-form-item>
                        </div>
                        
                    </div>
                </div>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save_examination" >保存</el-button >
        </div>
    </el-dialog>
</template>

<script>
import toujinglist from "../../utils/jiahao.js";
export default {
    props: ['show'],
    data () {
        return {
            labelWidth:'200px',
            activeVlaue:'tigetizhengbiaoList',
            activeIndex:1,
            navTab:[
                {value:'体格体征表',num:1,label:'tigetizhengbiaoList'},
                {value:'血常规',num:2,label:'xuechangguiList'},
                {value:'尿常规',num:3,label:'niaochangguiList'},
                {value:'大便常规',num:4,label:'dabianchangguiList'},
                {value:'血液生化',num:5,label:'xueyeshenghuaList'},
                {value:'血糖',num:6,label:'xuetangList'},
                {value:'凝血功能',num:7,label:'ningxuegongnengList'},
                {value:'血液流变学检验',num:8,label:'xueyeliubianxueList'},
                {value:'心脏和肌肉疾病相关检查',num:9,label:'xinzanghejirouList'},
                {value:'微量元素检测',num:10,label:'weiliangyuansuList'},
                {value:'血气分析表',num:11,label:'xueqifenxiList'},
                {value:'激素和内分泌检查',num:12,label:'jisuList'},
                {value:'肿瘤标志物检测',num:13,label:'zhongliubiaozhiwuList'},
                {value:'病毒性肝炎免疫标志物检测',num:14,label:'bingduxingList'},
                {value:'自身抗体检测',num:15,label:'zishenkangtiList'},
            ],
            listData:{
                tigetizhengbiaoList: toujinglist.tigetizhengbiao,
                xuechangguiList: toujinglist.xuechanggui,
                niaochangguiList: toujinglist.niaochanggui,
                dabianchangguiList: toujinglist.dabianchanggui,
                xueyeshenghuaList: toujinglist.xueyeshenghua,
                xuetangList: toujinglist.xuetang,
                ningxuegongnengList: toujinglist.ningxuegongneng,
                xueyeliubianxueList: toujinglist.xueyeliubianxue,
                xinzanghejirouList: toujinglist.xinzanghejirou,
                weiliangyuansuList: toujinglist.weiliangyuansu,
                xueqifenxiList: toujinglist.xueqifenxi,
                jisuList: toujinglist.jisu,
                zhongliubiaozhiwuList: toujinglist.zhongliubiaozhiwu,
                bingduxingList: toujinglist.bingduxing,
                zishenkangtiList: toujinglist.zishenkangti,
            },
        }
    },
    mounted () {
    },
    methods: {
        tab_click(item){
            this.activeIndex=item.num;
            this.activeVlaue = item.label;
        },
        save_examination(){
            let newArr=[];
            for(const key in this.listData){
                this.listData[key].forEach(item=>{
                    if(item.title){
                        let obj={
                            name:item.name,
                            title:item.title,
                            unit:item.unit
                        }
                        newArr.push(obj)
                    }
                })
            }
            this.$emit('save',newArr);
        },
        // 清空弹层
        clearTitle(){
            for(const key in this.listData){
                this.listData[key].forEach(item=>{
                    item.title=''
                })
            }
        },
        handleClose(){
            this.$emit('update:show',false)
        }
    }
}
</script>